export const CUSTOMER_ADDRESS_UPDATED = 'CUSTOMER_ADDRESS_UPDATED';
export const CUSTOMER_ADDRESS_SAVED = 'CUSTOMER_ADDRESS_SAVED';
export const CUSTOMER_ADDRESS_READY = 'CUSTOMER_ADDRESS_READY';

export function customerAddressUpdated(address) {
  return {
    type: CUSTOMER_ADDRESS_UPDATED,
    address,
  };
}

export function customerAddressSaved(values) {
  return {
    type: CUSTOMER_ADDRESS_SAVED,
    values,
  };
}

export function customerAddressDataReady(address) {
  return {
    type: CUSTOMER_ADDRESS_READY,
    address,
  };
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerAddressService/actions.js